import PillIcon from '../../../../icons/PillIcon';
import { useStyles } from '../../styles';
import { QeScoreKpiBreakdownMetric } from '../../interfaces';

export function KPIMetricEntry({
  metric,
}: {
  metric: QeScoreKpiBreakdownMetric;
}) {
  const classes = useStyles();
  const isCompliant = metric?.status?.toLowerCase().includes('achieving');
  const isNotApplicable = metric?.status
    ?.toLowerCase()
    .includes('not applicable');

  return (
    <div
      className={`flex items-center justify-between flex-1 last:border-b-0 ${classes.kpiMetricRow}`}
    >
      <span className={`text-base ${classes.kpiMetricNotApplicableValue}`}>
        {metric.process}
      </span>
      <div className="flex items-center gap-2 ml-2 flex-shrink-0">
        {!isNotApplicable && (
          <span
            className={`text-base font-semibold ${classes.kpiMetricScoreValue}`}
          >
            {`${metric.weightage}/${metric.weight}`}
          </span>
        )}

        {isNotApplicable ? (
          <span className={`text-base ${classes.kpiMetricNotApplicableValue}`}>
            N/A
          </span>
        ) : isCompliant ? (
          <PillIcon className={classes.kpiMetricCompliantIcon} />
        ) : (
          <PillIcon className={classes.kpiMetricNonCompliantIcon} />
        )}
      </div>
    </div>
  );
}
